import { render, staticRenderFns } from "./VCA_Vehicles.vue?vue&type=template&id=47462b3b&scoped=true&"
import script from "./VCA_Vehicles.vue?vue&type=script&lang=ts&"
export * from "./VCA_Vehicles.vue?vue&type=script&lang=ts&"
import style0 from "./VCA_Vehicles.vue?vue&type=style&index=0&id=47462b3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47462b3b",
  null
  
)

export default component.exports